import { useTranslation } from "react-i18next";

import { QuestionResultStatusSelector } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components";

import type { Intervention } from "models";

type InterventionSectionProps = {
  intervention: Intervention;
};

export const InterventionSection = ({ intervention }: InterventionSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="intervention-section">
      <div className="title">{t("v8_intervention", "Intervention")} </div>
      <div className="status-name-container">
        <h2 className="name-text">{intervention.title}</h2>
        <QuestionResultStatusSelector disabled={true} intervention={intervention} />
      </div>
      <div className="description">{intervention.description}</div>
    </div>
  );
};
